module.exports = __webpack_public_path__ + "img/tarj1-4.cab977a9.svg";